<template>
  <div id="privacy-policy">
    <call />
    <footer-app page="top"></footer-app>

    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right push-to-right-grey">
        <template v-if="isBackBtn">
          <div class="l-header__column l-header__column--left pl-16">
            <a href="javascript:history.back();"><img src="/assets/images/icon/icon-back-arrow.svg" alt=""></a>
          </div>
        </template>
        <template v-else>
          <div class="l-header__column l-header__column--left pl-16">
            <div class="l-header__btn-menu ssm-toggle-nav">
              <img
                src="/assets/images/icon/icon_menu_black.svg"
                class="l-header__btn-menu--open"
              />
              <img
                src="/assets/images/icon/icon-close.svg"
                class="l-header__btn-menu--close"
              />
            </div>
          </div>
        </template>
        <div class="l-header__column l-header__column--mid">
          プライバシーポリシー
        </div>
        <div class="l-header__column l-header__column--right w-60"></div>
      </div>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white pb-50">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                プライバシーポリシー
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-8">
              <div class="c-about-group c-about-group-border-none mb-34">
                <div class="c-about-group__policy mb-16">
                  基本方針
                </div>
                <div style="line-height: 1.8">
                  <p class="mb-30 ">
                    イオンタウン株式会社（以下「当社」といいます）は、「お客さまを原点に平和を追求し、人間を尊重し、地域社会に貢献する」という当社グループの企業理念のもと、個人情報の重要性を認識し、これら個人情報を適切に利用し保護することが、当社の事業活動の基本であると共に、当社の社会的責任であると考え、信頼を一層確かなものにする活動を実施いたします。
                  </p>
                  <p class="mb-30 ">
                    <b>●個人情報保護についての取組み</b><br>
                    当社は、個人情報保護に関する基本方針を徹底するために以下の活動を行います。
                  </p>
                  <p class="mb-30 ">
                  役員およびすべての従業員は、個人情報に関する法令および社内の規範を遵守します。 <br>
                  個人情報保護管理責任者を選任し、個人情報保護の実施および運用に関する責任および権限を与え、教育訓練等を実施して個人情報の厳重な管理を行います。 <br>
                  個人情報保護監査責任者を選任し、個人情報保護に関する監査を実施します。 <br>
                  不適合事項に対して、社内の規程、運用を改善します。 <br>
                  取引先および関係先に対し、個人情報保護のための協力を要請します。 <br>
                  本方針は、当社ホームページおよび会社案内などに掲載することによりいつでも閲覧可能な状態にします。
                  </p>
                  <p>
                  <b>●個人情報の取扱いについて </b><br>
                  収集、利用、提供については、収集時に利用目的を明らかにし、収集した個人情報は、必要な期間に限り、その利用目的の範囲内で使用します。また、利用する必要がなくなったときは、当該個人情報を遅滞なく消去するよう努めます。 <br>
                  個人情報に対し、開示・訂正・中止を求められたときは、合理的な期間、妥当な範囲内でこれに速やかに応じます。 <br>
                  安全対策の実施については、不正アクセス、紛失、改ざん、漏えいなどの問題が起きないように適切に取扱います。
                  </p>
                </div>
                <div class="text-right" style="line-height: 1.8">
                  <p>
                  制定　2011年9月1日<br>
                  改定　2022年4月1日<br>
                  イオンタウン株式会社<br>
                  代表取締役社長 加藤　久誠
                  </p>
                </div>
              </div>
              <div class="c-about-group c-about-group-border-none mb-28">
                <div class="c-about-group__policy mb-16">
                  個人情報の取扱いについて
                </div>
                <div style="line-height: 1.8">
                  <p class="mb-30 ">
                    当社は、お客さまが当社のショッピングセンター（以下「店舗」といいます）内の商品およびサービス等を安心してご購入、ご利用いただけるよう、お客さまに係る個人情報の取扱いに細心の注意を払います。当社、役員および従業員は、個人情報を保護することの重要性を認識し、法令遵守および安全な取扱いの維持向上を図ります。
                  </p>
                  <p class="mb-30 ">
                    <b>・お客さまの個人情報の取扱いについて </b><br>
                    １．個人情報の利用目的について（お客さまの個人情報を適切に取得・利用します。）<br>
                    当社は、お客さまが当社のサービスを円滑かつ効率的にご利用できるように、お客さまから氏名、住所、電話番号等の個人情報をご提供いただき、これを取得しております。当社が取得する個人情報の利用目的は、次のとおりです。なお、当社が個人情報を取得する場合には、適切な方法で利用目的の通知または公表を行います
                  </p>
                  <p class="mb-30 ">
                  (1)お客さまがご購入された製品、商品等に関する配達のため <br>
                  (2)お客さまに関して、各種会員制サービスへの登録を行うため <br>
                  (3)お客さまに対して、展示会、セミナー、コンテスト、懸賞、スポーツジム等の各種イベントまたは店舗をご案内するため <br>
                  (4)お客さまに対するアンケートについては、当該アンケートの目的達成のため <br>
                  (5)お客さまからのお問合せ（ご意見、ご感想）や資料請求などに対応するため<br>
                  (6)お客さまとの通話内容の録音および当社の店舗等での撮影については、防犯または会話内容の確認のため <br>
                  (7)お客さまの購買履歴やウェブサイト閲覧履歴等の情報を分析し、マーケティングおよび販売促進に利用するため <br>
                  (8)当社が取得するクレジットカード番号、有効期限その他の情報についてはその代金の決済等のため <br>
                  (9)当社によるＷＡＯＮカードその他の前払式証票の発行、発行後の管理、利用状況の確認その他これらに関連する業務を行うため <br>
                  (10)当社の店舗に関する市場調査や新しい店舗企画開発のため
                  </p>
                  <p class="mb-30 ">
                    ２．利用の制限について（所定の利用目的以外の利用はいたしません。）<br>
                    当社は、上記１に記載した利用目的の達成のために必要な範囲を超えた利用（目的外利用）はいたしません。
                  </p>
                  <p class="mb-30 ">
                    ３．事業の譲渡（合併等の場合においても適切な処置を講じます。） <br>
                    当社は企業として、合併や資産の売却または買収をする場合がございます。その場合、利用目的の範囲内でお客さまの個人情報が提供される場合がありますが、当社は、提供先に対してお客さまの個人情報取扱に関する管理義務を含む契約を締結するなど必要な措置を講じます。
                  </p>
                  <p class="mb-30 ">
                    ４．個人情報の管理について（適切な管理を行います。） <br>
                    当社は、管理責任者を置き、個人情報に関する法令・業界ガイドライン・社内規程などを遵守するとともに、お客さまの個人情報の取扱いについて細心の注意を払います。また、当社は、お客さまの個人情報を正確かつ最新の状態に保つよう努力し、お客さまの個人情報に関して不正アクセス・紛失・破壊・改ざん・漏えいなどが起こらないように、適切な管理を実施いたします。当社が行う具体的な管理措置は、例えば以下のとおりです。
                  </p>
                  <p class="mb-30 ">
                    (1)当社は、お客さまの個人情報の保護と適切な取扱いに関して、社内教育を継続して実施しています。 <br>
                    (2)当社は、定期的に適切な監査を行い、個人情報保護に係るマネジメントシステムを見直しいたします。
                  </p>
                  <p class="mb-30 ">
                    ５．個人情報の第三者への提供について（第三者に対して不適切な提供はいたしません。） <br>
                    当社は、以下のいずれかに該当する場合を除き、お客さまの個人情報を第三者に提供いたしません。
                  </p>
                  <p class="mb-30 ">
                    <b>・お客さま本人の同意がある場合</b><br>
                    当社は、お客さまの同意に基づき、お客さまの個人情報を第三者に提供することがございます。 <br>
                    なお、当社は、お客さまがクレジットカードその他の決済手段を利用して商品の購入またはサービスを利用された場合に、その代金の決済等を目的として、クレジットカードその他の決済用カードの番号、お客さまのお名前その他必要な情報をクレジットカード会社、その他金融機関に情報提供することがございます。 この場合には、お客さまは、当社による上記情報提供にご同意いただいたものとします。
                  </p>
                  <p class="mb-30 ">
                    <b>・法令に基づく場合</b><br>
                    当社は、以下の場合に、お客さまの情報を第三者に提供することがございます。 <br>
                    (1)法令に基づく場合 <br>
                    (2)人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき <br>
                    (3)公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき <br>
                    (4)国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
                  </p>
                  <p class="mb-30 ">
                  <b>・個人情報の取り扱いの委託を行う場合</b><br>
                  当社は、お客さまの個人情報の取り扱いを外部業者等へ委託する場合に、お客さまの個人情報を当社の厳正な管理下のもと、必要最小限の範囲で委託先の外部業者等に提供等することがございます。
                  </p>
                  <p class="mb-30 ">
                    <b>・グループでの共同利用を行う場合</b><br>
                    当社は、お客さまの個人データを、当社グループにて、共同して利用させていただくことがございます。 
                  </p>
                  <p class="mb-30 ">
                    (1)共同利用する個人データの項目 <br>
                    i. 氏名、生年月日、性別、電話番号、住所、電子メールアドレス、ご家族に関する情報、ご勤務先に関する情報、お客様の資産・負債に関する情報、お取引ニーズに関する情報、公開情報など、お客様の属性に関する情報、その他、お客さまが申告された情報 <br>
                    ii. お取引いただいている各種商品やサービス等の種類、ご契約日・お取引金額・残高・期日など、お客さまとの個々のお取引の内容に関する情報 <br>
                    iii. お客様のグループ各社の購買履歴、ウェブサイト閲覧履歴などの当社グループが提供するサービスの利用に関する情報
                  </p>
                  <p class="mb-30 ">
                    (2)共同して利用する者の範囲 <br>
                    イオン株式会社の有価証券報告書に記載された国内の連結対象会社および各社が持分法適用会社としている国内の関連会社（ただし、個人情報保護法第27条第5項第3号に基づく対外告知を実施済みの会社を対象とします。）イオンのグループ会社は<a href="#" @click.prevent="openPdf('https://www.aeon.info/company/group/')" class="color-2 " target="_blank">こちら</a>をご参照ください。
                  </p>
                  <p class="mb-30 ">
                    (3)共同利用する者の利用目的 <br>
                    「1. 個人情報の利用目的について」に準じます。
                  </p>
                  <p class="mb-30 ">
                    (4)当該個人データの管理について責任を有する者 <br>
                    イオンタウン株式会社　代表取締役社長　加藤 久誠<br>
                    住所：千葉県千葉市美浜区中瀬一丁目５番地１
                  </p>
                  <p class="mb-30 ">
                    ・ポイントサービスにおける共同利用 
                  </p>
                  <p class="mb-30 ">
                    当社は、以下に定めるとおり、保有する個人データを適切な保護措置を講じたうえで、以下の当社グループ各社との間で、共同利用することがあります。 <br>
                    (1)共同利用する個人データの項目 <br>
                    i. 氏名、生年月日、性別、電話番号、住所、電子メールアドレス、ご家族に関する情報、ご勤務先に関する情報、お客様の資産・負債に関する情報、お取引ニーズに関する情報、公開情報など、お客様の属性に関する情報、その他、お客さまが申告された情報 <br>
                    ii. お取引いただいている各種商品やサービス等の種類、ご契約日・お取引金額・残高・期日など、お客さまとの個々のお取引の内容に関する情報
                  </p>
                  <p class="mb-30 ">
                    (2)共同して利用する者の範囲 <br>
                    下記の会社と共同利用いたします。 <br>
                    共同して利用する者 <br>
                    イオン株式会社<br>
                    イオンリテール株式会社 <br>
                    株式会社イオン銀行 <br>
                    イオンマーケティング株式会社 <br>
                    イオンクレジットサービス株式会社
                  </p>
                  <p class="mb-30 ">
                    (3)共同利用する者の利用目的 <br>
                    i. ポイントサービス、各種特典等のお客さまへのご提供のため <br>
                    ii. 共同利用者による、共同利用者・提携会社及び加盟店の各種商品やサービス、通信販売等に関するお客さまへのご提案やご案内のため <br>
                    iii. 各種商品やサービス等の企画・開発のため <br>
                    iv. 各種商品・サービス提案に際しての会員情報分析のため
                  </p>
                  <p class="mb-30 ">
                    (4)当該個人データの管理について責任を有する者 <br>
                    イオン株式会社　取締役兼代表執行役社長　吉田 昭夫<br>
                    住所：千葉県千葉市美浜区中瀬一丁目５番地１
                  </p>

                  <p class="mb-30 ">
                    ６．個人情報のお問い合わせについて <br>
                    当社は、「お客さまの個人情報の相談窓口」を設け、お客さまからお届けいただいたお客さまの個人情報の開示、訂正、利用停止に関するお問い合わせについて、法令の範囲内で、すみやかに対応させていただきます。例えば、次のようなご要望をお持ちのお客さまは、「お客さまの個人情報の相談窓口」までご相談ください。 <br>
                    (1)当社の登録情報に誤りがあり、これを訂正したいとのご要望 <br>
                    (2)当社からのｅメール、ダイレクトメール、携帯電話等によるご案内について、停止してほしいとのご要望
                  </p>
                  <p>
                  ７．16歳未満のお客さまの個人情報について（保護者の許可を求めます。） <br>
                  当社は、16歳未満のお客さまの個人情報保護についても最大限の注意を払います。16歳未満のお客さまの個人情報については、保護者の方の同意の下にご提供いただいきます。
                  </p>
                  <p class="mb-30 ">
                  ・その他 
                  </p>
                  <p class="mb-30 ">
                    １．管轄裁判所について <br>
                    当社の個人情報の保護に関して紛議が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所といたします。
                  </p>
                  <p class="mb-30 ">
                  ２．お客さまの個人情報に係る相談窓口 <br>
                  イオンタウン株式会社 総務部<br>
                  電話番号：043-212-6369<br>
                  FAX番号：043-212-6449<br>
                  お問合せフォーム：<br>
                  <a href="#" @click.prevent="openPdf('mailto:at-soumu@aeonpeople.biz')" class="color-2 " target="_blank">at-soumu@aeonpeople.biz</a>
                  </p>
                  <p class="mb-30 ">
                  ・改訂について<br>
                  当社では、個人情報保護を図るため、または法令その他の規範の変更に対応するために、個人情報保護方針について一部を改訂することがございます。特に重要な変更については、当社ウェブサイトまたは最寄りの店舗において当社所定の分かりやすい方法でお知らせいたします。
                  </p>
                  <p class="mb-30 ">
                    ・ウェブサイトの利用について
                  </p>
                  <p class="mb-30 ">
                    Cookie（クッキー）及びSSLの利用について<br>
                    Cookie（クッキー）は、お客さまが当社のサイトに再度訪問された際、より便利に当サイトを閲覧していただくためのものであり、お客さま個人を特定することはございません。またお客さまはクッキーの使用を制限することができます。その場合、一部サービスがご利用になれないことがございます。 また、当社のサイトでは個人情報を入力していただく部分にはすべてSSL（Secure Sockets Layer）のデータ暗号化システムを利用しております。さらに、サイト内における情報の保護にもファイアウォールを設置するなどの方策を採っております。ただし、インターネット通信の性格上、セキュリティを完全に保証するものではありません。あらかじめご了承ください。
                  </p>
                  <p class="mb-30 ">
                    ・ウェブサイトの内容について <br>
                    当社ウェブサイトは、法律の異なる全世界の国々からアクセスすることも可能ですが、当社ウェブサイトの内容に関しては、日本国の法律に従うものといたします。また、当社ウェブサイト上の掲載物が違法とする地域からのアクセスは禁止といたします。
                  </p>
                  <p class="mb-30 ">
                    ・ウェブサイトで情報提供を拒否した時の影響 <br>
                    お客さまは、お客さまの個人情報を登録または提供することなく当社ウェブサイトをご利用することができます。ただし、その場合、特定のサービスをご利用いただけない場合もございます。また、ＩＤまたはパスワードなどが入力されてない場合、頻繁にＩＤやパスワードなどの要求がされることがございます。
                  </p>
                  <p class="mb-30 ">
                    ・開示請求手続き <br>
                    当社で保有している保有個人データに関して、ご本人さま又はその代理人さまからの利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止の請求（以下、「開示等の請求」といいます）につきましては、当社所定の請求書により、以下の手続きにて対応させていただきます。
                  </p>
                  <p class="mb-30 ">
                    １．「開示等の請求」申出先 <br>
                    「開示等の請求」は下記宛、当社所定の請求書に必要書類・手数料を同封の上、郵送によりお願い申し上げます。 <br>
                    イオンタウン株式会社 総務部<br>
                    電話番号：043-212-6369<br>
                    住所：千葉県千葉市美浜区中瀬一丁目５番地１
                  </p>
                  <p class="mb-30 ">
                    ２．「開示等の請求」に際してご提出いただく書類 <br>
                    「開示等の請求」を行う場合は、(1)の請求書に所定の事項を全てご記入の上、ご郵送下さい。請求書用紙につきましては、
                    <a href="#" @click.prevent="openPdf(privacy_pdf_url)" class="color-2 " target="_blank">PDF</a>
                    ファイルをダウンロードし、印刷してご記入ください。尚、ご本人確認のため、(2)の本人確認書類の写しのいずれかを同封してください。<br>
                    (1)当社所定の請求書 <br>
                    開示、利用目的の通知、訂正、削除、利用の停止、および第三者提供の停止 <br>
                    <a href="#" @click.prevent="openPdf(privacy_pdf_url)" class="color-2 " target="_blank">「保有個人データ開示等請求書」（PDF）</a> <br>
                    (2)本人確認書類の写し（下記のうちいずれか1点） <br>
                    １．運転免許証 <br>
                    ２．パスポート <br>
                    ３．個人番号（マイナンバー）カード（表面のみ） <br>
                    ４．健康保険の被保険者証 <br>
                    ５．年金手帳 <br>
                    ６．外国人登録証明書 <br>
                    ※本籍地の情報は都道府県以外を黒く塗りつぶしてください。 <br>
                    ※個人番号(マイナンバー)カードの場合は個人番号を含まない表面のみコピーしてください。 <br>
                  </p>
                  <p class="mb-30 ">
                    ３．代理人さまによる「開示等の請求」の場合 <br>
                    「開示等の請求」をする方が代理人さまである場合は、2.の(1)の書類に加えて、下記3.(1)の代理人である事を証明する書類の写しのいずれか及び3.(2)代理人さまご自身を証明する書類の写しのいずれかを同封してください。 <br>
                    (1)代理人である事を証明する書類 <br>
                    １．本人の委任状（実印を押印したものおよび印鑑証明書を添付） <br>
                    ２．その他代理権を有する証となる書類（戸籍謄本、住民票【続柄の記載されたもの】）
                  </p>
                  <p class="mb-30 ">
                    (2)代理人さまご自身を証明する書類の写し <br>
                    １．運転免許証 <br>
                    ２．パスポート <br>
                    ３．個人番号（マイナンバー）カード（表面のみ） <br>
                    ４．健康保険の被保険者証 <br>
                    ５．年金手帳 <br>
                    ６．外国人登録証明書<br>
                    ※本籍地の情報は都道府県以外を黒く塗りつぶしてください。 <br>
                    ※個人番号(マイナンバー)カードの場合は個人番号を含まない表面のみコピーしてください。
                  </p>
                  <p class="mb-30 ">
                    ４．「開示等の請求」の手数料及びお支払い方法 <br>
                    個人情報の開示請求、利用目的の通知につきましては、１回の請求につき、以下の金額を申し受けます。下記金額分の郵便定額小為替を請求書類の郵送時に同封してください。 <br>
                    手数料：１，０００円 
                  </p>
                  <p class="mb-30 ">
                    「開示等の請求」に対する回答方法 <br>
                    請求書記載のご本人さま住所宛に書面（封書郵送）又はご本人さまに同意いただいた方法にてご回答申し上げます。
                  </p>
                  <p class="mb-30 ">
                    ◇「開示等の請求」にともない取得した個人情報は、開示等の請求への対応に必要な範囲に限り、取り扱います。 <br>
                    ◇以下の場合には、「開示等の請求」にお応えできない場合があります。その場合は、その旨と理由をご通知申し上げます。また、不開示の場合についても実費分の費用を負担いただきますのでご承知ください。 <br>
                    １．ご本人さま又は代理人さまの本人確認できない場合 <br>
                    ２．所定の申請書類に不備があった場合 <br>
                    ３．開示等の請求の対象が「保有個人データ」(※下記記載)に該当しない場合 <br>
                    ４．ご本人さま又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合 <br>
                    ５．当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合 <br>
                    ６．法令に違反することとなる場合 
                  </p>
                  <p class="mb-30 ">
                    ※ 保有個人データとは、体系的に構成した情報の集合物を構成する個人情報であって、当社が、ご本人から求められる内容の開示、訂正、削除、利用の停止、および第三者への提供の停止の求めのすべてに応じることができる権限を有するものです。ただし、以下a)～d)のいずれかに該当する場合は保有個人データには該当しません。 <br>
                    a)当該個人情報の存否が明らかになることによって、本人又は第三者の生命、身体又は財産に危害が及ぶおそれのあるもの <br>
                    b)当該個人情報の存否が明らかになることによって、違法又は不当な行為を助長し、又は誘発するおそれのあるもの <br>
                    c)当該個人情報の存否が明らかになることによって、国の安全が害されるおそれ、他国若しくは国際機関との信頼関係が損なわれるおそれ又は他国若しくは国際機関との交渉上不利益を被るおそれのあるもの <br>
                    d)当該個人情報の存否が明らかになることによって、犯罪の予防、鎮圧又は捜査その他の公共の安全と秩序維持に支障が及ぶおそれのあるもの
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import { Common } from "../common/common.js";
import Vue from "vue";
import firebaseConfig from "../config/firebaseConfig.json";
export default Vue.extend({
  name: 'PrivacyPolicy',
  components: {
    'footer-app': Footer,
    'menu-app': Menu,
  },
  mixins: [Tenant],
  data() {
    return {
      isBackBtn: Common.getUrlParam('is_back_btn'),
      privacy_pdf_url:null
    }
  },
  async created() {
    const isStg = firebaseConfig.projectId.indexOf("-stg") != -1;
    this.privacy_pdf_url = isStg ? `https://appstg.a-town-app.com/pdf/privacy/personal.pdf` : `https://a-town-app.com/pdf/privacy/personal.pdf`
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    openPdf(url) {
      Common.messageHandlers('show_browser', { url: url });
    }

  }
})
</script>
